const module = { name: 'canvas/microSite/app', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { Fandango_adobeLaunch as adobeLaunch } from 'require-global';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as videoLinksUI } from 'swug-fdRequire-call:movie/shared/desktop/videoLinksUI';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


const Selectors = {
    CAROUSEL: '.fd-carousel',
    CAROUSEL_LINK: '.js-fd-carousel-focus-elem',
    LINK: '.js-link',
}
function attachLaunchEvents() {
    const { EventTypes } = adobeLaunch;
    $(Selectors.LINK).on('click', (e) => {
        let event;
        const isTheColorPurple = $(e.currentTarget).hasClass('color-purple__button');
        switch (e.currentTarget.dataset.type.toLowerCase()) {
            case 'main':
                event = isTheColorPurple ? EventTypes.MICROSITE_GIFT_TICKET_CLICK : EventTypes.MICROSITE_MAIN_BTN_CLICK;
                break;
            case 'secondary':
                event = isTheColorPurple ? EventTypes.MICROSITE_FIND_TICKETS_CLICK : EventTypes.MICROSITE_SECONDARY_BTN_CLICK;
                break;
            case 'card-1':
                event = isTheColorPurple ? EventTypes.MICROSITE_GIFT_TICKET_CLICK : EventTypes.MICROSITE_CARD_1_CLICK;
                break;
            case 'card-2':
                event = isTheColorPurple ? EventTypes.MICROSITE_BOOK_GROUP_CLICK : EventTypes.MICROSITE_CARD_2_CLICK;
                break;
            default:
                break;
        }
        adobeLaunch.track({
            event
        });
    });
    $(Selectors.CAROUSEL_LINK).on('click', (e) => {
        const { mpxId, isVideo, url } = e.currentTarget.dataset;
        adobeLaunch.track({
            event: EventTypes[isVideo !== 'false' ? 'MICROSITE_TRAILER_CLICK' : 'MICROSITE_CONTENT_CLICK'],
            mpxId,
            url,
        });
    });
}
function run() {
    checkDependencies(module.name, debugLog);
    const carouselID = $(Selectors.CAROUSEL).attr('id');
    fdCarousel.init(carouselID, isMobile ? {
        padding: { left: 0, right: 0 },
        fixedWidth: '220px',
    } : {
        padding: { left: 0, right: 0 },
    });
    videoLinksUI.attach();
    attachLaunchEvents();
}
run();
export default module.exports;